import type { GarageSignupUserInput, SignupUserInput } from '../apollo/graphql/signup.mutation';

const LOGIN_CHALLENGE_DATA = 'jerry-login-challenge-data';
const GARAGE_SIGNUP_DATA = 'jerry-garage-signup-data';

export enum ChallengeOption {
  IHaveTheAccount = 'I have the account',
  CreateANewAccount = 'Create a new account',
  IDontRemember = 'I dont remember',
}

/**
 * Save the login challenge data to local storage.
 */
export const saveLoginChallengeData = (data: SignupUserInput['input']): void => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(LOGIN_CHALLENGE_DATA, JSON.stringify(data));
};

/**
 * Get the login challenge data from local storage.
 */
export const getLoginChallengeData = (): SignupUserInput['input'] | undefined => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  const value = localStorage.getItem(LOGIN_CHALLENGE_DATA);
  if (value) {
    try {
      return JSON.parse(value) as SignupUserInput['input'];
    } catch {
      // ignore
    }
  }
};

export const saveGarageSignupData = (data: GarageSignupUserInput['input']): void => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(GARAGE_SIGNUP_DATA, JSON.stringify(data));
};

/**
 * Get the login challenge data from local storage.
 */
export const getGarageSignupData = (): GarageSignupUserInput['input'] | undefined => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  const value = localStorage.getItem(GARAGE_SIGNUP_DATA);
  if (value) {
    try {
      return JSON.parse(value) as GarageSignupUserInput['input'];
    } catch {
      // ignore
    }
  }
};
